import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import { useWindowSize } from "../../hooks/index";
import { Close } from "@mui/icons-material";
import { HTTPClient } from "../../HTTPClient";
import { usePlace } from "../../providers/PlaceProvider";
import { useNavigate } from "react-router-dom";

interface CreateCampaignDialogProps {
  open: boolean;
  setOpen: (b: boolean) => void;
  place?: boolean;
  onboarding?: boolean;
}

export default function CreateCampaignDialog({
  open,
  setOpen,
  place,
  onboarding,
}: CreateCampaignDialogProps) {
  const { t } = useTranslation("", { keyPrefix: "modals.createCampaign" });
  const { width } = useWindowSize();

  const { createPlace, changePlace } = usePlace();
  const navigate = useNavigate();

  const [value, setValue] = useState("");

  const handleClose = () => {
    setValue("");
    onboarding ? (window.location.href = "/campaign") : setOpen(false);
  };

  const handleSubmit = () => {
    if (place) {
      createPlace({ label: value }).then((newPlace) => {
        handleClose();
        changePlace(newPlace.id);
      });
    } else
      HTTPClient.post("/admin/demo-campaign/", { label: value })
        .then(({ data }) => {
          handleClose();
          changePlace(data.id);
          navigate("/campaign");
        })
        .catch((err) => {
          console.log(err);        
});
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <Close
        sx={{
          position: "absolute",
          top: "10px",
          right: "10px",
          cursor: "pointer",
          p: "7px",
          borderRadius: "50%",
          backgroundColor: "#F6F6F6",
          color: "#767575",
        }}
        fontSize="large"
        onClick={handleClose}
      />

      <DialogTitle>{t("create" + (place ? "Place" : ""))}</DialogTitle>

      <DialogContent>
        <div style={{ width: width < 1000 ? "100%" : "500px" }}>
          <TextField
            sx={{ width: "100%" }}
            value={value}
            onChange={(evt) => setValue(evt.target.value)}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          disabled={!value}
          variant="contained"
          onClick={handleSubmit}
          sx={{
            padding: "8px 60px",
            textTransform: "none",
            borderRadius: "6px",
            alignSelf: "self-end",
          }}
        >
          {t("submit")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
